export const zIndexes = {
  base: 0,
  productImageCarousel: 1,
  navItems: 3,
  increment: 10,
  toast: 102,
  borderfree: 20,
  flyout: 100,
  overlay: 1100,
};
